const UPDATE_USER = 'UPDATE_USER';
const UPDATE_ADDITIONAL_USER_INFO = 'UPDATE_ADDITIONAL_USER_INFO';
export { UPDATE_USER, UPDATE_ADDITIONAL_USER_INFO };
